"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ResetPassword;
var react_1 = __importStar(require("react"));
var primitives_1 = require("web/components/primitives");
// @ts-ignore
var user_1 = require("shared/api/user");
// @ts-ignore
var form_container_1 = __importDefault(require("web/components/public/form-container"));
var password_util_1 = require("shared/utils/password.util");
// @ts-ignore
var security_util_1 = require("shared/utils/security.util");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var baseDomain = window.clientConfig.baseDomain;
function ResetPassword(_a) {
    var match = _a.match;
    var _b = match.params, token = _b.id, tenant = _b.tenant;
    var _c = (0, react_1.useState)(), tokenData = _c[0], setTokenData = _c[1];
    var _d = (0, react_1.useState)(), error = _d[0], setError = _d[1];
    var _e = (0, react_1.useState)(false), loading = _e[0], setLoading = _e[1];
    var _f = (0, react_1.useState)({
        password: '',
        passwordConfirm: '',
    }), form = _f[0], setForm = _f[1];
    (0, react_1.useEffect)(function () {
        (0, user_1.isValidResetPasswordToken)(baseDomain, tenant, token)
            .then(function (result) {
            if (result.isError) {
                throw result;
            }
            setTokenData({ userType: result.userType });
        })
            .catch(function (err) { return setError(err.message); });
    }, [token, tenant]);
    if (!tokenData) {
        return null;
    }
    var onSetForm = function (update) {
        if (error) {
            setError(undefined);
        }
        setForm(__assign(__assign({}, form), update));
    };
    var onSubmit = function () {
        setLoading(true);
        (0, user_1.doPasswordReset)(baseDomain, tenant, token, form.password)
            .then(function (result) {
            if (result.isError) {
                throw result;
            }
            window.location.replace("/".concat(tenant));
        })
            .catch(function (err) { return setError(err.message); })
            .then(function () { return setLoading(false); });
    };
    var userIsAnyStaff = (0, security_util_1.isAnyStaff)({ type: tokenData.userType });
    return (react_1.default.createElement(form_container_1.default, { title: "Reset Password", actionTitle: "Reset", onSubmit: onSubmit, isLoading: loading, isValid: (0, password_util_1.validPassword)({
            password: form.password,
            passwordConfirm: form.passwordConfirm,
            userIsAnyStaff: userIsAnyStaff,
        }) },
        react_1.default.createElement("input", { type: "hidden", id: "userType", name: "userType", value: tokenData.userType }),
        !!error && (react_1.default.createElement(primitives_1.MessageAlert, { type: primitives_1.MessageAlertType.error, className: styles_scss_1.default.infoMessage }, error)),
        react_1.default.createElement(primitives_1.FormRow, { noMargin: true, label: "Password" },
            react_1.default.createElement(primitives_1.Input, { id: "password", type: "password", name: "password", value: form.password, onChange: function (e) {
                    return onSetForm({ password: e.target.value });
                } })),
        react_1.default.createElement(primitives_1.FormRow, { label: "Confirm Password" },
            react_1.default.createElement(primitives_1.Input, { id: "passwordConfirm", type: "password", name: "passwordConfirm", value: form.passwordConfirm, onChange: function (e) {
                    return onSetForm({ passwordConfirm: e.target.value });
                } })),
        react_1.default.createElement(primitives_1.PasswordRequirements, { password: form.password, userIsAnyStaff: userIsAnyStaff, passwordConfirm: form.passwordConfirm, className: styles_scss_1.default.requirements })));
}
